import { apiClient } from "api";
import { TNotification, TNotificationDeviceAction, TNotificationInput } from "./models/notification.types";

export const getNotifications = async () => {
  const response = await apiClient.get(`notifications`);
  return response.data;
};

export const getAppUsers = async (accountId: string): Promise<string[]> => {
  const response = await apiClient.get(`notifications/users/${accountId}`);
  return response.data;
};

export const sendNotification = async (data: TNotificationInput): Promise<TNotification[]> => {
  const response = await apiClient.post("notifications", data);
  return response.data;
};

export const triggerDeviceAction = async (data: TNotificationDeviceAction): Promise<any> => {
  try{
    return await apiClient.post("notifications", data);
  }
  catch(err: any){
    console.error("err", err.response.data.message);
    throw new Error(err.response.data.message);
  }
};
